import { DropdownOptionDto } from "@/api/models/common.model";
import { ProductDependencyDto } from "@/api/product-dependencies";
import { ProductGroupDependenciesByProductType } from "@/models/product.model";

const clearStorage = (state: any) => {
	Object.keys(state).forEach((key) => {
		state[key] = undefined;
	});
};

const saveDropdownData = (state: any, { key, data }: { key: string; data: DropdownOptionDto[] }) => {
	state[key] = data;
};

const saveConfiguration = (state: any, { key, data }: { key: string; data: any }) => {
	state[key] = data;
};

const saveProductGroupsDependencies = (state: any, { data }: { data: ProductGroupDependenciesByProductType }) => {
	state.productGroupsDependencies = data;
};

const saveProductNonGroupsDependencies = (state: any, { data }: { data: ProductDependencyDto[] }) => {
	state.productNonGroupsDependencies = data;
};

export default {
	clearStorage,
	saveConfiguration,
	saveDropdownData,
	saveProductGroupsDependencies,
	saveProductNonGroupsDependencies
};
